import { useTranslation } from '@thoughtspot/i18n';
import { getGuidsToSkip } from '@thoughtspot/session-service';
import React, { useEffect, useState } from 'react';
import { useGetGroupsPrincipalListQuery, useGetUserDetailsByIdLazyQuery, } from "../../../../services/user-group/user-group-service";
import { AddUsersToGroupsModal } from './add-users-to-groups-modal';
export const AddUsersToGroupsModalContainer = ({ onAddUsersToGroupsConfirm, onAddUsersToGroupsModalClose, isModalOpen, userIds = [], showLoader = false, }) => {
    const { t } = useTranslation();
    const [groupIds, setGroupIds] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [filteredGroupList, setFilteredGroupList] = useState([]);
    const [groupListInput, setGroupListInput] = useState({
        sort: 'NAME',
        sortAscending: true,
        batchSize: 100,
        offset: 0,
        pattern: '%%',
        skipIds: getGuidsToSkip(),
    });
    const { data: userByIdData, error: userByIdError, loading: userByIdLoading, getUserById, } = useGetUserDetailsByIdLazyQuery(userIds);
    const { data: groupsList, error: groupsListError, loading: groupsListLoading, refetch: refreshGroupsList, } = useGetGroupsPrincipalListQuery(groupListInput);
    useEffect(() => {
        getUserById();
    }, []);
    const updateGroupListPayload = (searchTerm) => {
        setGroupListInput({
            ...groupListInput,
            pattern: `%${searchTerm?.trim()}%`,
        });
    };
    const filterListData = (data = []) => {
        setFilteredGroupList(data);
    };
    return (React.createElement(AddUsersToGroupsModal, { isModalOpen: isModalOpen, onAddUsersToGroupsConfirm: onAddUsersToGroupsConfirm, onAddUsersToGroupsModalClose: onAddUsersToGroupsModalClose, userIds: userIds, groupIds: groupIds, filteredGroupList: filteredGroupList, groupList: groupList, usersData: userByIdData?.getUserDetailById, updateGroupListPayload: updateGroupListPayload, showLoader: groupsListLoading, filterListData: filterListData, groupsList: groupsList, setFilteredGroupList: setFilteredGroupList, setGroupIds: setGroupIds, setGroupList: setGroupList }));
};
//# sourceMappingURL=add-users-to-groups-modal.container.js.map